import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Calendar, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EventsPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (!authLoading && !user) navigate("/login"); }, [user, authLoading, navigate]);

  useEffect(() => {
    axios.get(`${API}/events`).then(res => setEvents(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (authLoading || !user) return null;

  return (
    <div data-testid="events-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Calendar</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Events</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white min-h-[50vh]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-20"><Loader2 className="w-6 h-6 text-[#C8A97E] animate-spin mx-auto" /></div>
          ) : events.length === 0 ? (
            <div className="text-center py-20">
              <Calendar className="w-12 h-12 text-[#E5E2DC] mx-auto mb-4" />
              <p className="text-[#595959]">No upcoming events. Check back soon.</p>
            </div>
          ) : (
            <div className="space-y-4">
              {events.map((ev) => (
                <div key={ev.id} data-testid={`event-${ev.id}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-6 flex gap-5">
                  <div className="w-14 h-14 rounded-lg bg-[#1C2E4A] flex flex-col items-center justify-center shrink-0 text-white">
                    <span className="text-xs font-medium">{new Date(ev.date).toLocaleDateString("en", { month: "short" })}</span>
                    <span className="text-lg font-bold leading-none">{new Date(ev.date).getDate()}</span>
                  </div>
                  <div>
                    <h3 className="font-serif text-base font-semibold text-[#1C2E4A] mb-1">{ev.title}</h3>
                    {ev.time && <p className="text-xs text-[#C8A97E] font-medium mb-1">{ev.time}</p>}
                    <p className="text-sm text-[#595959]">{ev.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
